$('.slick-collection').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 2,
  prevArrow: '<button class="slide-arrow left"><img src="https://cdn.shopify.com/s/files/1/0354/1683/4181/files/icon-arrow?v=1669372658"/></button>',
  nextArrow: '<button class="slide-arrow right"><img src="https://cdn.shopify.com/s/files/1/0354/1683/4181/files/icon-arrow?v=1669372658"/></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

if(window.innerWidth < 1024){
  
$('.multicolumn-slider,.multicolon-logo').slick({
  dots: false,
  infinite: false,
  speed: 300,
  prevArrow: '<button class="slide-arrow left"><img src="https://cdn.shopify.com/s/files/1/0354/1683/4181/files/icon-arrow?v=1669372658"/></button>',
  nextArrow: '<button class="slide-arrow right"><img src="https://cdn.shopify.com/s/files/1/0354/1683/4181/files/icon-arrow?v=1669372658"/></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});}
	
